import { Maybe, Organization } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

import { DisposalOrderLinePipe } from './disposal-order-line.pipe';

import { DeepPartial } from '@iss/wo-common/types';
import { ProductCategory } from '@iss/wo-common/trade-off';

type OrderLineData = Readonly<{
  treatmentFacility: Maybe<DeepPartial<Organization>>;
  productData: Readonly<{
    productCategory: ProductCategory;
  }>
}>;
type OrderLine<T extends OrderLineData> = T;
type OrderLinePipeInput<T extends OrderLineData> = readonly OrderLine<T>[];

export const isTreatmentFacilityOrderLine = (input: OrderLineData) => Boolean(input.treatmentFacility);

@Pipe({
  name: 'treatmentFacilityOrderLine',
  standalone: true,
})
export class TreatmentFacilityOrderLines implements PipeTransform {
  public transform<T extends OrderLineData>(input: OrderLinePipeInput<T>): OrderLine<T> | undefined {
    return input.find(isTreatmentFacilityOrderLine) || new DisposalOrderLinePipe().transform(input);
  }
}
